export var truncateMiddle = function truncateMiddle(str, length, separator) {
  if (str === void 0) {
    str = '';
  }

  if (separator === void 0) {
    separator = '...';
  }

  if (!str) {
    return '';
  }

  if (str.length <= length) return str;
  var sepLen = separator.length,
      charsToShow = length - sepLen,
      frontChars = Math.ceil(charsToShow / 2),
      backChars = Math.floor(charsToShow / 2);
  return str.substring(0, frontChars) + separator + str.substring(str.length - backChars);
};